import { VisibilityOutlined, VisibilityOffOutlined } from "@material-ui/icons";
import { Formik } from "formik";
import { useState } from "react";
import { connect } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import * as utils from "../../../_metronic/utils/utils";
import LoginBox from "../../components/login/LoginBox";
import * as auth from "../../store/ducks/auth.duck";
import * as onboarding from "../../store/ducks/onboarding.duck";
import { login } from "../../crud/auth.crud";
import InputCustom from "../../components/InputCustom";
import Button from "../../components/Button";
import styles from "../../styles/Login.module.scss";

function Login(props) {
	const history = useHistory();
	const [loading, setLoading] = useState(false);
	const [showPassword, setShowPassword] = useState(false);

	const enableLoading = () => {
		setLoading(true);
	};

	const disableLoading = () => {
		setLoading(false);
	};

	return (
		<>
			<div className="login-inner flex-column">
				<LoginBox titulo={'Bem vindo(a) à Chof'} subtitulo={'Insira os dados solicitados abaixo para acessar sua conta.'} size={'small'}>
					<Formik
						initialValues={{ email: "", password: "" }}
						validate={(values) => {
							const errors = {};

							if (!values.email) {
								errors.email = "O email é uma informação obrigatória.";
							} else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
								errors.email = "Você precisa informar um email válido.";
							}

							if (!values.password) {
								errors.password = "A senha é uma informação obrigatória.";
							}

							return errors;
						}}
						onSubmit={async (values, { setStatus, setSubmitting }) => {
							enableLoading();

							await login(values.email, values.password)
								.then(response => {
									utils.setStorage("authToken", response.data.token, null);

									props.login(response.data);

									if (response.data.onboarding) {
										props.setOnboarding(response.data.onboarding);
									}

									if (response.data.user?.usr_primeiro_acesso) {
										history.push("/auth/primeiro-acesso");
									} else {
										history.push("/inicio");
									}
								})
								.catch(err => {
									setStatus(err.response.data.errors[0]);
								})
								.finally(() => {
									setSubmitting(false);
									disableLoading();
								});
						}}
					>
						{({ values, status, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
							<form noValidate={true} autoComplete="off" className="kt-form" onSubmit={handleSubmit}>
								{status ? (
									<div role="alert" className="alert alert-danger">
										<div className="alert-text">{status}</div>
									</div>
								) : null}

								<div className={styles.formBlock}>
									<InputCustom
										label={"E-mail"}
										name={"email"}
										type={"email"}
										value={values.email}
										onBlur={handleBlur}
										onChange={handleChange}
										disabled={loading}
										errors={errors}
										touched={touched}
									/>

									<InputCustom
										label={"Senha"}
										name={"password"}
										type={showPassword ? "text" : "password"}
										value={values.password}
										onBlur={handleBlur}
										onChange={handleChange}
										disabled={loading}
										errors={errors}
										touched={touched}
										icon_left={showPassword ? <VisibilityOutlined /> : <VisibilityOffOutlined />}
										icon_style={{ cursor: "pointer" }}
										onIconClick={() => setShowPassword(!showPassword)}
									/>

									<Link className="forgot" to={"/password/forgot"}>
										Esqueceu sua senha?
									</Link>
								</div>

								<div className="kt-login__actions" style={{ margin: '40px 0 0 0' }}>
									<Button
										type="submit"
										disabled={isSubmitting}
										variant="primary"
										size="lg"
										height="lg"
										outlined={false}
										fullWidth={true}
										loading={loading}
										children="Entrar"
									/>
								</div>
							</form>
						)}
					</Formik>

					<span className={styles.divider} />

					<div className={styles.buttonBlock}>
						<p>Ainda não possui conta? Clique no botão abaixo e cadastre-se agora.</p>

						<Button
							type="button"
							disabled={loading}
							variant="primary"
							outlined
							size="lg"
							height="lg"
							fullWidth={true}
							loading={loading}
							children="Criar conta"
							onClick={() => history.push("/auth/register")}
						/>
					</div>
				</LoginBox>
			</div>
		</>
	);
}

export default connect(null, { ...auth.actions, ...onboarding.actions })(Login);
